/**
 * Таймлайн процесу: дві механіки з концепту.
 *
 * 1. Вузли загоряються по черзі, коли крок в'їжджає у вьюпорт (клас .on).
 * 2. Кожна наступна плашка підіймається на пів висоти попередньої — саме це
 *    дає зигзаг із центральною лінією; без цього кроки стоять рівним стовпцем
 *    і блок виглядає зовсім інакше, ніж у дизайні.
 *
 * Пошук у межах секції блока: id тут задає редактор, і блок може бути не один.
 */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.phpdev-services').forEach(function (root) {
    var steps = [].slice.call(root.querySelectorAll('.tstep'));
    if (!steps.length) return;

    /* ---------- 1. підсвічування ---------- */
    if (reduce) {
      steps.forEach(function (st) { st.classList.add('on'); });
    } else {
      var queued = false;

      function tick() {
        queued = false;
        var vh = innerHeight || 800;
        steps.forEach(function (st) {
          st.classList.toggle('on', st.getBoundingClientRect().top < vh * 0.74);
        });
      }

      function onScroll() {
        if (!queued) { queued = true; requestAnimationFrame(tick); }
      }

      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll, { passive: true });
      tick();
    }

    /* ---------- 2. зигзаг ---------- */
    var GAP = 14; // мінімальний просвіт між плашками одного боку

    function layout() {
      // у вузькій розкладці кроки йдуть звичайним стовпцем
      /* парне значення до @media(max-width:991px) у style.scss — міняти разом */
      var stacked = matchMedia('(max-width:991px)').matches;
      steps.forEach(function (st) { st.style.marginTop = ''; });
      if (stacked) return;

      for (var j = 1; j < steps.length; j++) {
        var prev = steps[j - 1];
        var card = prev.querySelector('.tl-body');
        if (!card) continue;
        var want = card.offsetHeight * 0.5 + GAP; // бажаний крок між верхами плашок
        var shift = want - prev.offsetHeight;     // плашка разом із нижнім відступом
        steps[j].style.marginTop = (shift < 0 ? shift : 0) + 'px';
      }
    }

    var t;
    layout();
    addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(layout, 150);
    }, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(layout);
    }
  });
})();
